module.exports = __webpack_public_path__ + "img/Ch_window.24c27093.png";